import { Link } from 'react-router-dom'

const linkClass = 'hover:text-text-secondary hover:underline'

export function MarketingFooter() {
  return (
    <>
      <Link to="/uptime-monitoring" className={linkClass}>
        Uptime monitoring
      </Link>
      {' · '}
      <Link to="/slack-uptime-alerts" className={linkClass}>
        Slack alerts
      </Link>
      {' · '}
      <Link to="/email-uptime-alerts" className={linkClass}>
        Email alerts
      </Link>
      {' · '}
      <Link to="/public-status-pages" className={linkClass}>
        Status pages
      </Link>
      {' · '}
      <Link to="/ssl-domain-monitoring" className={linkClass}>
        SSL & domain
      </Link>
      {' · '}
      <Link to="/alternatives" className={linkClass}>
        Alternatives
      </Link>
      {' · '}
      <Link to="/pricing" className={linkClass}>
        Pricing
      </Link>
      {' · '}
      <Link to="/refund" className={linkClass}>
        Refund
      </Link>
      {' · '}
      <Link to="/terms" className={linkClass}>
        Terms
      </Link>
      {' · '}
      <Link to="/privacy" className={linkClass}>
        Privacy
      </Link>
      {' · '}
      <Link to="/cookies" className={linkClass}>
        Cookies
      </Link>
      {' · '}
      <Link to="/contact" className={linkClass}>
        Contact
      </Link>
    </>
  )
}
